import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Experience, WMAIApiService, SchedaIntense, Attachment, Item, Stop, Word, AppStatus, Ost, GisQureyResult } from '../../core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, AppInformationService, ExpLocalStorage, S3Service, GeolocationService } from '../../core/services';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators, NgModel } from '@angular/forms';
import { ImageModal, ConfirmModal, SimpleModal, ConfirmFormModal } from 'src/app/core/templates';
import { SuiModalService, TemplateModalConfig, ModalTemplate, ModalSize } from 'ng2-semantic-ui';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { throwIfEmpty } from 'rxjs/operators';
import { callbackify } from 'util';
import { Subscription } from 'rxjs';
import { transferArrayItem } from '@angular/cdk/drag-drop';
import { TouchSequence } from 'selenium-webdriver';
import * as foo from '../../core/models/functions-cordova';
import { Point } from 'ol/geom';
import { Coordinate } from 'ol/coordinate';
import WKT from 'ol/format/WKT';

declare var window: any;
declare var cordova: any;
declare var LocalFileSystem: any;

@Component({
  selector: 'app-saved-experience',
  templateUrl: './saved-experience.component.html'
})

export class SavedExperienceComponent implements OnInit, OnDestroy {
  isMapVisible: boolean = false;
  isUserLoggedIn = false;
  isMyExp = false;
  localOst: Ost[] = [];

  esperienza: Experience;
  esperienza_online: Experience;
  schedaintense: SchedaIntense;
  loading: boolean = true;
  firstStep: boolean = false;
  secondStep: boolean = false;
  thirdStep: boolean = false;
  fourthStep: boolean = false;

  canIEdit: boolean = false;

  isSmallScreen: boolean = false;
  immagine: Attachment;
  immagini: Attachment[] = [];
  currentIndex: number = 0;
  maxIndex: number = 0;
  allegati: Attachment[] = [];
  allegato: Attachment;

  mainForm: FormGroup;
  titolo: string = "";
  htmlContent: string = "";

  itemForm: FormGroup;
  itemtitolo: string = "";
  itemcontent: string = "";
  selectedItem: Item;
  selectedStop: Stop;
  stops: Stop[] = [];
  items: Item[];
  itemdefaulttitle: string;
  itemAllegati: Attachment[] = [];
  itemImmagini: Attachment[] = [];
  itemImmagine: Attachment;
  itemCurrentIndex: number = 0;
  itemMaxIndex: number = 0;
  ostDescrizione: string;

  geomtype: string = 'point';

  ostSubscription: any;

  checkDownload: boolean;
  checkSyncronize: boolean;

  subscriptions: Subscription;

  connectionStatusMessage: string;
  connectionStatus: boolean;

  resolved(captchaResponse: string) {
    // console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private wmaiservice: WMAIApiService,
    private auth: AuthService,
    private wgisservice: WgisService,
    private breakpointObserver: BreakpointObserver,
    private activatedroute: ActivatedRoute,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private modalService: SuiModalService,
    private appService: AppInformationService,
    private explocalstorage: ExpLocalStorage,
    private s3Service: S3Service,
    private geolocation: GeolocationService,
    private zone: NgZone
  ) {
    this.isUserLoggedIn = this.auth.isUserLoggedIn();
    this.connectionStatus = this.appService.getCurrentConnectionStatus();
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });
    this.isSmallScreen = breakpointObserver.isMatched('(max-width: 768px)');
    this.subscriptions = this.appService.onlineStatus.subscribe(data => {
      this.connectionStatus = data;
    });
  }

  ngOnInit() {
    const titoloCtrl = new FormControl(this.titolo, [Validators.required, Validators.maxLength(50)]);
    const contentCtrl = new FormControl(this.htmlContent);

    this.mainForm = this.formBuilder.group({
      titolo: new FormControl(titoloCtrl),
      htmlContent: new FormControl(contentCtrl),
    });

    this.mainForm.controls['titolo'].patchValue('');
    this.mainForm.controls['htmlContent'].patchValue('');

    const itemtitoloCtrl = new FormControl(this.itemtitolo, [Validators.required, Validators.maxLength(50)]);
    const itemcontentCtrl = new FormControl(this.itemcontent);

    this.itemForm = this.formBuilder.group({
      itemtitolo: new FormControl(itemtitoloCtrl),
      itemcontent: new FormControl(itemcontentCtrl),
    });

    this.itemForm.controls['itemtitolo'].patchValue('');
    this.itemForm.controls['itemcontent'].patchValue('');

    this.checkExperienceInLocalStorage();
  }

  ngOnDestroy() {
    this.appService.changeAppStatus(AppStatus.None);
    // this.wgisservice.clearSelection();
    this.subscriptions.unsubscribe();
    this.ostSubscription.unsubscribe();
  }
  /**
   * controlla le esperienze nella memoria locale, se non dovesse essere nullo si va a crare la pagina in base al suo 
   * contenuto, mentre se dovesse essere vuota si va a controllare se l'utente che lo ha richiesta è autenticato
   * nel frattempo richiede se lo stato della applicazione è online oppure no, se dovesse essere on allora si va creare
   * una tappa, siccome è vuota, altrimenti errore.
   * Tutto questo nella lingua locale.
   */
  checkExperienceInLocalStorage() {
    // console.log("Downloaded");

    this.wgisservice.clearSelection();
    var localExp: Experience = this.explocalstorage.getExperience();
    var ost: Ost[] = this.explocalstorage.getLocalOst();
    if (localExp != null) {
      this.esperienza = localExp;
      this.stops = this.esperienza.stops;
      if (ost != null) {
        this.localOst = ost;
        this.wgisservice.showOsts(ost);
      }
      //l'esperienza sarÃ  solo privata
      this.canIEdit = true;
      this.secondStep = true;
      this.appService.changeAppStatus(AppStatus.EditExp);

      this.appService.changeSelectedExperience(this.esperienza);
      this.wgisservice.showEsperienzaByObj(this.esperienza);
      this.mainForm.controls['titolo'].patchValue(this.esperienza.title);
      this.mainForm.controls['htmlContent'].patchValue(this.esperienza.content == null ? '' : this.esperienza.content);
      this.loading = false;
    } else {
      this.router.navigate(['/bio/' + this.auth.getIdUser()]);
    }
    this.ostSubscription = this.appService.newOst.subscribe((ost: GisQureyResult) => {
      this.zone.run(() => {
        if (this.appService.getCurrentAppStatus() == AppStatus.EditExp) {
          if (ost != null && ost.tipo == 'ost') {
            if (this.selectedStop != null) {
              if (this.checkTappa(ost.id).length == 0) {
                var item: Item = new Item();
                item.ost_id = ost.id;
                item.geom = ost.geom;
                item.title = ost.titolo;
                item.stop = this.selectedStop.stop;
                item.fk_experience = this.esperienza.id;
                this.selectedStop.items.push(item);
                this.explocalstorage.setExperience(this.esperienza);
                let title: string = this.translateService.instant('modal.esperienza.addOst.title');
                let content: string = this.translateService.instant('modal.esperienza.addOst.success');
                this.modalService
                  .open(new SimpleModal(title, content, ModalSize.Tiny))
                  .onApprove(() => "")
                  .onDeny(() => {
                    this.selectedItem = item;
                  });
              } else {
                let title: string = this.translateService.instant('modal.esperienza.addOst.title');
                let content: string = this.translateService.instant('modal.esperienza.addOst.errorExist');
                this.modalService
                  .open(new SimpleModal(title, content, ModalSize.Tiny))
                  .onApprove(() => "")
                  .onDeny(() => "");
              }
            } else {
              let title: string = this.translateService.instant('modal.esperienza.addOst.title');
              let content: string = this.translateService.instant('modal.esperienza.addOst.errorSelection');
              this.modalService
                .open(new SimpleModal(title, content, ModalSize.Tiny))
                .onApprove(() => "")
                .onDeny(() => "");
            }
          } else {
            let title: string = this.translateService.instant('modal.esperienza.addOst.title');
            let content: string = this.translateService.instant('modal.esperienza.addOst.errorInvalid');
            this.modalService
              .open(new SimpleModal(title, content, ModalSize.Tiny))
              .onApprove(() => "")
              .onDeny(() => "");
          }
        }
      });
    });
  }
  /** si controlla la tappa attraverso il parametro
   * @param  {number} id
   */
  checkTappa(id: number) {
    //da verificare tale funzione
    return this.selectedStop.items.filter(item => item.ost_id == id || item.id == id)
  }
  /**
   * mappa a video
   */
  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }
  /**
   * prossima immagine
   */
  nextImage() {
    if (this.currentIndex >= this.maxIndex) this.currentIndex = 0;
    else this.currentIndex++;
    this.immagine = this.immagini[this.currentIndex];
  }
  /**
   * immagine precendente
   */
  previousImage() {
    if (this.currentIndex <= 0) this.currentIndex = this.maxIndex;
    else this.currentIndex--;
    this.immagine = this.immagini[this.currentIndex];
  }
  /**
   * prossimo oggetto dell'immagine
   */
  nextItemImage() {
    if (this.itemCurrentIndex >= this.itemMaxIndex) this.itemCurrentIndex = 0;
    else this.itemCurrentIndex++;
    this.itemImmagine = this.itemImmagini[this.itemCurrentIndex];
  }

  /**
  * oggetto precedente dell'immagine
  */
  previousItemImage() {
    if (this.itemCurrentIndex <= 0) this.itemCurrentIndex = this.itemMaxIndex;
    else this.itemCurrentIndex--;
    this.itemImmagine = this.itemImmagini[this.itemCurrentIndex];
  }
  /** attraverso i parametri fa vedere l'immagine tramite modal
   * @param  {string} title
   * @param  {string} url
   */
  onShowImage(title: string, url: string) {
    if (url != null || url != "") {
      this.modalService
        .open(new ImageModal(title, url))
        .onDeny(() => "");
    }
  }
  /** fitra gli elementi eliminati
   * @param  {Item[]} array
   */
  hideDeleted(array: Item[]) {
    return array.filter(item => {
      return item.status != 'delete';
    });
  }
  /** attraverso il parametro si cambia la fermata
   * @param  {Stop} stop
   */
  changeSelectedStop(stop: Stop) {
    this.selectedStop = stop;
  }
  /** si punta all'item selezionato
   * @param  {Item} item
   */
  onSelectedItem(item: Item): void {
    if (item != null) {
      this.itemAllegati = [];
      this.itemImmagini = [];
      this.selectedItem = item;
      // console.log(item);
      this.selectedStop = this.esperienza.stops.find(stop => stop.stop == this.selectedItem.stop);
      this.itemForm.controls['itemcontent'].patchValue(this.selectedItem.content == null ? '' : this.selectedItem.content);
      this.itemForm.controls['itemtitolo'].patchValue(this.selectedItem.title);
      this.ostDescrizione = '';
      this.getItemAttachments();
      this.ostDescrizione = item.ost_descrizione ? item.ost_descrizione : '';
      this.appService.changeSelectedItem(this.selectedItem);
      this.wmaiservice.selectedItem.emit(this.selectedItem);
      this.wgisservice.showItemByObj(this.selectedItem, true);
    }
  }
  /** si aggiorna l'elemento sezionato e si apre un modal con tutti i requisiti a partire dalla traduzione
   * @param  {Item} item
   */
  onUpdateItem(item: Item) {
    if (item != null) {
      item.title = this.itemForm.controls['itemtitolo'].value;
      item.content = this.itemForm.controls['itemcontent'].value == null ? '' : this.itemForm.controls['itemcontent'].value;
      this.explocalstorage.setExperience(this.esperienza);
      let title: string = this.translateService.instant('modal.esperienza.save.title');
      let content: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
      this.modalService
        .open(new SimpleModal(title, content, ModalSize.Tiny))
        .onApprove(() => "")
        .onDeny(() => "");
    }
  }
  /** si va ad aggiungere un file se è selezionato l'oggetto non nullo 
   * @param  {} event
   *
   */
  onAddFile(event) {
    if (this.selectedItem) {
      const ext = event.target.files[0].name.substr(event.target.files[0].name.lastIndexOf('.') + 1);
      // console.log(ext);
      foo.saveAttachmentInDir(event.target.files[0], event.target.files[0].name);
      var attachment: Attachment = new Attachment();
      attachment.resource_url = cordova.file.dataDirectory + "temp/" + event.target.files[0].name;
      attachment.uploadedname = event.target.files[0].name;
      // console.log(this.selectedItem);
      this.selectedItem.attachtments.push(attachment);
      this.getItemAttachmentsUpload();
      // console.log(event.target.value);
      event.target.value = '';
      // console.log(event.target.value);
      // console.log(attachment);
    }
  }
  /** si va a rimuovere un file passato come parametro e fa uscire un modal se è avvenuto con successp
   * @param  {Attachment} allegato
   */
  onRemoveFile(allegato: Attachment) {
    let title: string = this.translateService.instant('modal.esperienzaedit.item.title');
    let content: string = this.translateService.instant('modal.esperienzaedit.item.content');
    if (this.selectedItem != null) {
      this.modalService
        .open(new ConfirmModal(title, content, ModalSize.Tiny))
        .onApprove(() => {
          if (allegato.status != null && allegato.status != undefined) {
            allegato.status = 'delete';
          } else {
            this.selectedItem.attachtments = this.selectedItem.attachtments.filter(element => {
              if(allegato != element){
                return element;
              }
            });
            foo.deleteAttachmentFile(allegato.uploadedname);
          }
          this.getItemAttachments();
          //this.explocalstorage.setExperience(this.esperienza);
          let titlec: string = this.translateService.instant('modal.esperienza.save.title');
          let contentc: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
          this.modalService
            .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
            .onApprove(() => "")
            .onDeny(() => "");
        })
        .onDeny(() => "");
    }
  }
  /**
   *si pulisce tutto il form e non si punta più a nessun oggetto
   */
  onReset() {
    if (this.selectedItem.sysdefined)
      this.itemForm.controls['itemcontent'].patchValue('');
    else {
      this.itemForm.controls['itemtitle'].patchValue(this.selectedItem.title);
      this.itemForm.controls['itemcontent'].patchValue('');
    }
  }
  /**
   * si va ad aggiungere un oggetto se non è presente attraverso un modal ricevo un messaggio, altrimenti
   * vado ad aggiungere seguendo la descrizione che mi richiede e si settano i rispettivi parametri
   */
  onAddItem(): void {
    if (this.selectedStop == null) {
      let title: string = this.translateService.instant('modal.esperienza.additem.title');
      let content: string = this.translateService.instant('modal.esperienza.additem.content');
      this.modalService
        .open(new SimpleModal(title, content, ModalSize.Tiny))
        .onApprove(() => "")
        .onDeny(() => "");
    } else {
      this.loading = true;
      const idWatch = navigator.geolocation.watchPosition((position) => {
        navigator.geolocation.clearWatch(idWatch);
        this.itemAllegati = [];
        this.itemImmagini = [];
        let itemname: string = this.translateService.instant('core.default.newitem');
        let newItem: Item = new Item();
        var coord = [];
        coord.push(position.coords.longitude);
        coord.push(position.coords.latitude);
        var wkt = new WKT();
        newItem.geom = wkt.writeGeometry(new Point(coord));
        newItem.title = itemname;
        newItem.content = "";
        newItem.sysdefined = false;
        newItem.stop = this.selectedStop.stop;
        newItem.fk_experience = this.esperienza.id;
        this.selectedStop.items.push(newItem);
        this.selectedItem = newItem;
        this.explocalstorage.setExperience(this.esperienza);
        this.loading = false;
      }, (error)=> {
        navigator.geolocation.clearWatch(idWatch);
        this.loading = false;
        alert(JSON.stringify(error))
      })
      
      
      //carico in esperienza
      
      // navigator.geolocation.getCurrentPosition(
      //   (position: Position) => {
      //   console.log("entrato");
      //   var coord = [];
      //   coord.push(position.coords.longitude);
      //   coord.push(position.coords.latitude);
      //   var wkt = new WKT();
      //   newItem.geom = wkt.writeGeometry(new Point(coord));
      //   this.explocalstorage.setExperience(this.esperienza);
      //   console.log(this.selectedItem);
      //   this.loading = false;
      // }, (error: PositionError) => {
      //   this.loading = false;
      // });
      // this.explocalstorage.setExperience(this.esperienza);
    }
  }
  /**
   *si vanno a settare degli array con gli oggetti attaccati agli allegati e alle immagini
   */
  getItemAttachments() {
    this.itemImmagini = [];
    this.itemAllegati = [];
    if (this.selectedItem != null && this.selectedItem.attachtments != null) {

      this.selectedItem.attachtments.forEach(attachment => {
        if (attachment.id != null && attachment.id != undefined && attachment.uploadedname.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
          var path = cordova.file.dataDirectory + this.esperienza.id + '/' + this.selectedItem.stop.replace(/ /g, "_") + '/' + this.selectedItem.id + '/';
          var type = foo.typeFile(attachment.uploadedname);
          path = path + attachment.id + type;
          attachment.resource_url = decodeURI(path);
          this.itemImmagini.push(attachment);
        } else if (attachment.uploadedname.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
          this.itemImmagini.push(attachment);
          this.itemAllegati.push(attachment);
        } else {
          this.itemAllegati.push(attachment);
        }
      });
      if (this.itemImmagini.length > 0) {
        this.itemCurrentIndex = 0;
        this.itemImmagine = this.itemImmagini[this.itemCurrentIndex];
        this.itemMaxIndex = this.itemImmagini.length - 1;
      }
    }
  }
  /**
   * si va riempire degli array con gli aggetti degl allegati e delle immagini
   */
  getItemAttachmentsUpload() {
    this.itemImmagini = [];
    this.itemAllegati = [];
    if (this.selectedItem != null && this.selectedItem.attachtments != null) {

      this.selectedItem.attachtments.forEach(attachment => {
        if (attachment.id != null && attachment.id != undefined && attachment.uploadedname.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
          var path = cordova.file.dataDirectory + this.esperienza.id + '/' + this.selectedItem.stop.replace(/ /g, "_") + '/' + this.selectedItem.id + '/';
          var type = foo.typeFile(attachment.uploadedname);
          path = path + attachment.id + type;
          attachment.resource_url = decodeURI(path);
          this.itemImmagini.push(attachment);
        } else {
          this.itemAllegati.push(attachment);
        }
      });
      if (this.itemImmagini.length > 0) {
        this.itemCurrentIndex = 0;
        this.itemImmagine = this.itemImmagini[this.itemCurrentIndex];
        this.itemMaxIndex = this.itemImmagini.length - 1;
      }
    }
  }
  /** si apre un modal dell'oggetto dove c'è la possibilità di eliminarlo
   * @param  {Item} item
   */
  onDeleteItem(item: Item): void {

    let title: string = this.translateService.instant('modal.esperienzaedit.item.title');
    let content: string = this.translateService.instant('modal.esperienzaedit.item.content');
    if (item != null) {
      if (item.sysdefined != true) {
        this.modalService
          .open(new ConfirmModal(title, content, ModalSize.Tiny))
          .onApprove(() => {
            if (item.status != null || item.status != undefined) {
              item.status = 'delete';
            } else {
              this.selectedStop.items = this.selectedStop.items.filter(element => element != item);
            }
            this.explocalstorage.setExperience(this.esperienza);
            this.selectedItem = null;
            let titlec: string = this.translateService.instant('modal.esperienza.save.title');
            let contentc: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
            this.modalService
              .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
              .onApprove(() => "")
              .onDeny(() => "");
          })
          .onDeny(() => "");
      }
    }
  }
  /**
   * si va a salvare l'azione svolta attraverso un modal
   */
  save() {
    let title: string = this.translateService.instant('modal.esperienza.save.title');
    let content: string = this.translateService.instant('modal.esperienza.save.content');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        this.esperienza.title = this.mainForm.controls['titolo'].value;
        this.esperienza.content = this.mainForm.controls['htmlContent'].value == null ? '' : this.mainForm.controls['htmlContent'].value;
        this.explocalstorage.setExperience(this.esperienza);
        let titlec: string = this.translateService.instant('modal.esperienza.save.title');
        let contentc: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
        this.modalService
          .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
          .onApprove(() => "")
          .onDeny(() => "");
      })
      .onDeny(() => "");
  }
  /**
   *si sincronizzano l'esperienze salvate all'interno della memoria locale
   */
  syncronizeEsperienza() {
    if (this.connectionStatus) {
      this.downloadFromLocalStorage();
    } else {
      let titlec: string = this.translateService.instant('modal.esperienza.syncronize.title');
      let contentc: string = this.translateService.instant('modal.esperienza.syncronize.errorNetwork');
      this.modalService
        .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
        .onApprove(() => "")
        .onDeny(() => "");
    }
  }
  /**
   * si scaricano l'esperienza dalla memoria locale, dopo aver controllato se l'utente è autorizzato
   */
  downloadFromLocalStorage() {
    let content = this.esperienza.content == null ? '' : this.esperienza.content;
    this.wmaiservice.updateEsperienza(this.esperienza.id, this.esperienza.scheda_id, this.auth.getID(), this.esperienza.title, content).subscribe(data => {

      this.loading = true;
      this.syncAllItems();

    });
  }
  /**
   * modal che attesta l'avvenuta sincronizzazione
   */
  syncIsDone() {
    this.loading = false;
    let titlec: string = this.translateService.instant('modal.esperienza.syncronize.title');
    let contentc: string = this.translateService.instant('modal.esperienza.syncronize.confirmcontent');
    this.modalService
      .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
      .onApprove(() => {

      })
      .onDeny(() => {
        this.removeExp();
      });
  }

  addItemFromLocalItem(items: Item[]) {
    if (items.length > 0) {
      items.forEach(item => {
        // console.log("Ecco item da sincronizzare: " + item.ost_id);
        if (item.ost_id != null && item.ost_id != undefined) {
          this.wmaiservice.addItemFromOst(item.stop, this.esperienza.id, item.ost_id).subscribe(data => {
            if (data != null) {
              item.id = data.item_id;
              item.attachtments.forEach(attachment => {
                const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                let formData = new FormData();
                formData.append('item_id', String(item.id));
                formData.append('fk_experience', String(item.fk_experience));
                formData.append('id', String(this.auth.getID()))
                foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service);
              })
            }
          });
        } else {
          this.wmaiservice.addItemToEsperienza(this.esperienza.id, item.stop, item.title, item.content, item.geom).subscribe(data => {
            if (data != null) {
              item.id = data.data[0].items_id;
              // console.log(item)
              item.attachtments.forEach(attachment => {
                const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                let formData = new FormData();
                formData.append('item_id', String(item.id));
                formData.append('fk_experience', String(item.fk_experience));
                formData.append('id', String(this.auth.getID()))
                foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service);

              })
            }
          });
        }
      });
      //pulizia del localStorage
      // this.explocalstorage.removeExperience();
      // this.explocalstorage.removeLocalItems();
      // this.explocalstorage.removeLocalOst();
    }
  }

  updateItems(items: Item[]) {
    if (items.length > 0) {
      items.forEach(item => {
        if (item.status == 'delete') {
          this.wmaiservice.delItemToEsperienza(this.esperienza.id, item.id).subscribe(data => {
            // console.log("Eliminato item: " + item.id);
          });
        } else {
          this.wmaiservice.updateEsperienzaItem(item.id, this.esperienza.id, item.title, item.content).subscribe(data => {
            if (data != null) {
              item.attachtments.forEach(attachment => {
                if (attachment.id == null || attachment.id == undefined) {
                  const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                  let formData = new FormData();
                  formData.append('item_id', String(item.id));
                  formData.append('fk_experience', String(item.fk_experience));
                  formData.append('id', String(this.auth.getID()))
                  foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service);
                }
              })
            }
          });
        }
      });
    }
  }

  async syncAllItems() {
    // console.log("syncAllItems");
    var promises = [];
    for (let stop of this.esperienza.stops) {
      for (let item of stop.items) {
        if (item.id == null || item.id == undefined) {
          // console.log("Ecco item da sincronizzare: " + item.ost_id);
          if (item.ost_id != null && item.ost_id != undefined) {
            await this.wmaiservice.addItemFromOst(item.stop, this.esperienza.id, item.ost_id).toPromise().then(data => {
              if (data != null) {
                item.id = data.item_id;
                item.attachtments.map((attachment) => {
                  const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                  let formData = new FormData();
                  formData.append('item_id', String(item.id));
                  formData.append('fk_experience', String(item.fk_experience));
                  formData.append('id', String(this.auth.getID()))
                  promises.push(foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service));
                });
              }
            });
          } else {
            await this.wmaiservice.addItemToEsperienza(this.esperienza.id, item.stop, item.title, item.content, item.geom).toPromise().then(data => {
              if (data != null) {
                item.id = data.data[0].items_id;
                // console.log(item)
                item.attachtments.map(attachment => {
                  const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                  let formData = new FormData();
                  formData.append('item_id', String(item.id));
                  formData.append('fk_experience', String(item.fk_experience));
                  formData.append('id', String(this.auth.getID()))
                  promises.push(foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service));
                });
              }
            });
          }
        } else {
          if (item.status == 'delete') {
            await this.wmaiservice.delItemToEsperienza(this.esperienza.id, item.id).toPromise().then(data => {
              // console.log("Eliminato item: " + item.id);
              promises.push(Promise.resolve(true));
            });
          } else {
            item.content = item.content == null ? '' : item.content;
            await this.wmaiservice.updateEsperienzaItem(item.id, this.esperienza.id, item.title, item.content).toPromise().then(data => {
              // console.log(data);
              if (data != null) {
                item.attachtments.map(attachment => {
                  if (attachment.id == null || attachment.id == undefined) {
                    const ext = attachment.uploadedname.substr(attachment.uploadedname.lastIndexOf('.') + 1);
                    let formData = new FormData();
                    formData.append('item_id', String(item.id));
                    formData.append('fk_experience', String(item.fk_experience));
                    formData.append('id', String(this.auth.getID()))
                    promises.push(foo.uploadAttachmentFile(attachment.uploadedname, item, formData, this.s3Service));
                  }
                });
              }
            });
          }
        }
      }
    };
    Promise.all(promises).then(values => {
      // console.log("Risultato promise", values);
      this.syncIsDone();
    });
  }

  // item nuovi dell'esperienza offline;
  getLocalItems() {
    var items: Item[] = [];
    this.esperienza.stops.forEach(stop => {
      stop.items.forEach(item => {
        if (item.id == null || item.id == undefined) {
          items.push(item);
        }
      });
    });
    return items;
  }
  /**
   * si ottengono gli elementi aggiornati che fanno parte delle fermate
   */
  getUpdatedItems() {
    var items: Item[] = [];
    this.esperienza.stops.forEach(stop => {
      stop.items.forEach(item => {
        if (item.id != null && item.id != undefined) {
          items.push(item);
        }
      });
    });
    return items;
  }
  /**
   * si pulisce dalla memoria locale l'esperienza salvata come anche la cache
   */
  removeExp() {
    foo.removeDirFolder(this.esperienza.id.toString());
    this.explocalstorage.removeExperience();
    this.explocalstorage.removeLocalItems();
    this.explocalstorage.removeLocalOst();
    let titlec: string = this.translateService.instant('modal.esperienza.removeCache.title');
    let contentc: string = this.translateService.instant('modal.esperienza.removeCache.confirmcontent');
    this.modalService
      .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
      .onApprove(() => {
      })
      .onDeny(() => {

        this.router.navigate(['esperienza/' + this.esperienza.id]);
      });
  }

  checkIcon(allegato: Attachment) {
    if (allegato.uploadedname.match(/\.(pdf|txt|doc|docx|exel|PDF|TXT|DOC|DOCX|EXEL)$/)) {
      return { "file alternate outline icon": true };
    } else if (allegato.uploadedname.match(/\.(mp3|MP3|wav|WAV|wma|WMA)$/)) {
      return { "file audio outline icon": true };
    } else if (allegato.uploadedname.match(/\.(3gp|avi|mp4|mpeg|mpg|3GP|AVI|MP4|MPEG|MPG)$/)) {
      return { "file video outline icon": true };
    } else if (allegato.uploadedname.match(/\.(jpg|jpeg|png|gif|bmp|JPG|JPEG|PNG|GIF|BMP)$/)) {
      return { "file image outline icon": true };
    } else {
      return { "download icon": true };
    }
  }

  convertLocalUrl(url: string){
    const resp = window.Ionic.WebView.convertFileSrc(url);
    return resp;
  }
}